/* @flow */
import gql from 'graphql-tag';

export const fragments = {
    SearchResult: gql`
        fragment FilterCountsSearchRequestResult on SearchResult {
            id
            resultCount
            filterGroups {
                groupInfo {
                    name
                    id
                }
                filters {
                    count @include(if: $filterCounts)
                    checked
                    filter {
                        id
                        name
                        refineByQueryArgument
                        description
                    }
                }
            }
        }
    `
};

export const FILTER_COUNT_SEARCH_REQUEST_QUERY_NAME =
    'SearchRequestFilterCountQuery';

export const filteredSearchRequestCountQuery = gql`
    query ${FILTER_COUNT_SEARCH_REQUEST_QUERY_NAME}($request: SearchResultRequest!, $filterCounts: Boolean! ) {
        results: search(request: $request) {
            ...FilterCountsSearchRequestResult
        }
    }
    ${fragments.SearchResult}
`;
